import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { Field, reduxForm } from "redux-form";
import LazyLoad from "react-lazy-load";
import { Tooltip, QrCodeStickerModal, ClipboardCopy } from "components";
import { Label, ModalPreview } from "expano-components";

import InputField from "./components/Input";
import { WarningModal } from "../../../../../components";
import { updateGrnLine, setGrnLinesFilter } from "actions/grns";

import { ReactComponent as QRcodeIcon } from "icons/qrcode.svg";
import { ReactComponent as Sticker } from "icons/sticker.svg";
import { ReactComponent as WarningIcon } from "icons/light-warning.svg";

const ItemRow = ({
  data: { id },
  form,
  search_value,
  updateGrnLine,
  handleSubmit,
  isBlocked,
  submitted,
  data,
  warehouse_id,
  setGrnLinesFilter,
}) => {
  const ref = useRef();
  const [is_warning_modal_open, openWarningModal] = useState(false);
  const [is_modal_open, openModal] = useState(false);
  const [is_qr_codes_modal_open, openQrCodesModal] = useState(false);
  const onSubmit = (values) => {
    if (!isBlocked) {
      const input_focused = ref?.current?.querySelector("input:focus");
      if (input_focused) {
        input_focused.blur();
      }
      updateGrnLine(id, values);
    } else {
      alert("zablokowane");
    }
  };
  const stock = data?.product?.product_main_locations?.find(
    (item) => item.warehouse?.id === Number(warehouse_id)
  )?.stock;

  const image_url = data.product?.image_url;
  return (
    <tr
      data-focus-id={data.id}
      className={classNames(data?.counting_state, {
        is_warned: data?.is_warned,
        is_decomposed:
          data?.supplier_quantity?.is_decomposed ||
          data?.supplier_quantity?.is_composed,
        no_location: !data.has_location_in_shipment_warehouse,
        deleted: data.is_deleted,
      })}
      style={{
        display: data?.show ? "table-row" : "none",
      }}
    >
      <td className="number">
        <span>{data?.no}</span>
      </td>
      <td className="image-box">
        {image_url && (
          <LazyLoad>
            <button
              tabIndex="-1"
              className="modal__trigger"
              onClick={() => openModal(true)}
              style={{
                backgroundImage: `url('${
                  data?.product?.image_thumb_url || image_url
                }')`,
              }}
            />
          </LazyLoad>
        )}
      </td>
      <td>{data?.product?.sku}</td>
      <td>
        <p>
          <a
            className="text-link"
            href={`/products/${data?.product?.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data?.product?.name}
          </a>
        </p>
        <p className="text-info">
          Kod dostawcy:{" "}
          {data?.supplier_code ? (
            <ClipboardCopy text={data?.supplier_code} />
          ) : (
            "-"
          )}
        </p>
        {!data.has_location_in_shipment_warehouse && (
          <Label
            type="fill"
            color="#fd397a"
            text="Brak lokalizacji na magazynie wysyłkowym"
          />
        )}
      </td>
      <td>{typeof stock === "number" ? `${stock} szt.` : "Brak danych"}</td>
      <td>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          {data.product?.has_ean && <Sticker style={{ marginRight: 5 }} />}
          {data.product?.sku && data?.product?.has_qr_code && (
            <button
              type="button"
              onClick={() => openQrCodesModal(true)}
              tabIndex="-1"
            >
              <QRcodeIcon />
            </button>
          )}
          {data.counting_state === "pending" &&
            search_value !== data.product.sku &&
            search_value !== data.product.ean &&
            data?.product?.has_ean && (
              <button
                type="button"
                style={{ padding: 5 }}
                onClick={() => openWarningModal(true)}
              >
                <WarningIcon />
              </button>
            )}
        </div>
      </td>
      <td>
        {data?.supplier_quantity?.is_decomposed ||
        data?.supplier_quantity?.is_composed ? (
          <>
            <p>
              <strong>
                {data.supplier_quantity.package_qty}{" "}
                {data.supplier_quantity?.supplier_custom_unit || "op."}
              </strong>
            </p>
            {data.supplier_quantity.unit_qty > 0 ? (
              <p>
                <strong>{data.supplier_quantity.unit_qty} szt.</strong>
              </p>
            ) : null}
            <p className="text-muted">{data?.quantity} szt.</p>
          </>
        ) : (
          <>
            <p>
              <strong>{data.quantity}</strong>
            </p>
            <p>{data?.unit}</p>
          </>
        )}
      </td>
      <td>
        <form onSubmit={handleSubmit(onSubmit)} ref={ref}>
          <Field
            form_name={form}
            name="counted_quantity"
            status={data?.counting_state}
            submitted={submitted}
            defaultValue={data?.counted_quantity ? data.counted_quantity : 0}
            component={InputField}
            isBlocked={
              isBlocked ||
              (data?.requires_supplier_batch_number_on_delivery &&
                !data?.supplier_batch_number)
            }
            submit={handleSubmit(onSubmit)}
            type="number"
          />
        </form>
      </td>
      {is_modal_open && (
        <ModalPreview
          handleClose={() => {
            openModal(false);
          }}
          src={image_url}
          alt={data?.product?.name}
        />
      )}
      {is_qr_codes_modal_open && (
        <QrCodeStickerModal
          data={data.product}
          handleClose={() => openQrCodesModal(false)}
          initialValues={{ quantity: data?.quantity || 1 }}
        />
      )}
      {is_warning_modal_open && (
        <WarningModal
          handleConfirm={() => {
            openWarningModal(false);
            setGrnLinesFilter("sku", data.ean || data.product.sku);
          }}
          handleClose={() => openWarningModal(false)}
          product={data.product}
        />
      )}
      <td>
        {data?.is_warned && (
          <Tooltip trigger={<WarningIcon />} content={<p>Sprawdź produkt</p>} />
        )}
        {data?.product?.is_warehouseman_alert_enabled &&
          data?.product?.warehouseman_alert && (
            <Tooltip content={<p>{data.product.warehouseman_alert}</p>} />
          )}
      </td>
    </tr>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateGrnLine: (id, data) => dispatch(updateGrnLine(id, data)),
  setGrnLinesFilter: (name, value) => dispatch(setGrnLinesFilter(name, value)),
});
export default connect(
  ({
    grn: {
      filters: { warehouse_id, sku },
    },
  }) => ({
    warehouse_id,
    search_value: sku,
  }),
  mapDispatchToProps
)(reduxForm()(ItemRow));
